import type {
  WatchlistFragmentType,
  WatchlistItemFragmentType,
} from './watchlist-fragment';

type QueryWatchlist = WatchlistFragmentType & {
  items: WatchlistItemFragmentType[];
};

export interface Response {
  id: string;
  name: string;
  keys: string[];
  itemsLimit: number;
  watchlist: QueryWatchlist | undefined;
}

export const getDefaultResponse = (): Response => ({
  id: '',
  name: '',
  keys: [],
  itemsLimit: 50,
  watchlist: undefined,
});

export const mapWatchlistResponseToCache = (
  watchlist: QueryWatchlist
): Response => ({
  id: watchlist.id ?? '',
  name: watchlist.name ?? '',
  keys: watchlist.items?.map((n) => n.companyId) || [],
  itemsLimit: watchlist.itemsLimit ?? 50,
  watchlist,
});
